import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Container, Typography, Box, Card, CardContent, CircularProgress, Snackbar,
} from '@mui/material';
import { motion } from 'framer-motion';
import axios from 'axios';

const AllEvents = () => {
  const { state } = useLocation();
  const { schoolId, userType } = state || {};
  const navigate = useNavigate();
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'error' });

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await axios.get('https://kidsm.vercel.app/api/schools/events', {
          params: { schoolId },
        });
        console.log('Fetched All Events:', response.data);
        setEvents(response.data);
      } catch (error) {
        console.error('Error fetching events:', error);
        setSnackbar({
          open: true,
          message: 'Failed to fetch events',
          severity: 'error',
        });
      } finally {
        setLoading(false);
      }
    };

    if (schoolId) fetchEvents();
  }, [schoolId]);

  if (!schoolId || !userType) {
    return (
      <Container maxWidth="md" sx={{ py: 4, bgcolor: '#f5f5f5', minHeight: '100vh' }}>
        <Typography variant="h6" sx={{ textAlign: 'center', color: '#e74c3c' }}>
          Error: Missing required parameters
        </Typography>
      </Container>
    );
  }

  if (loading) {
    return (
      <Container maxWidth="md" sx={{ py: 4, bgcolor: '#f5f5f5', minHeight: '100vh' }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
          <CircularProgress color="primary" />
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="md" sx={{ py: 4, bgcolor: '#f5f5f5', minHeight: '100vh' }}>
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
        <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#333', mb: 4 }}>
          All Events
        </Typography>

        {events.length === 0 ? (
          <Typography sx={{ fontSize: '1rem', color: '#666', textAlign: 'center', mt: 4 }}>
            No events found.
          </Typography>
        ) : (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {events.map((event) => (
              <Card
                key={event._id}
                onClick={() =>
                  navigate(userType === 'parent' ? '/parent-event-details' : '/event-details', { state: { event } })
                }
                sx={{
                  bgcolor: '#fff',
                  borderRadius: 2,
                  p: 2,
                  boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                  cursor: 'pointer',
                  '&:hover': { boxShadow: '0 4px 12px rgba(0,0,0,0.3)' },
                }}
              >
                <CardContent>
                  <Typography sx={{ fontSize: '1.125rem', fontWeight: 'bold', color: '#333', mb: 1 }}>
                    {event.eventName}
                  </Typography>
                  <Typography sx={{ fontSize: '1rem', color: '#666', mb: 0.5 }}>
                    Date: {new Date(event.dateTime).toLocaleString()}
                  </Typography>
                  <Typography sx={{ fontSize: '1rem', color: '#666' }}>
                    Venue: {event.venue}
                  </Typography>
                </CardContent>
              </Card>
            ))}
          </Box>
        )}
      </motion.div>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        message={snackbar.message}
        sx={{ bgcolor: snackbar.severity === 'error' ? '#e74c3c' : '#4CAF50' }}
      />
    </Container>
  );
};

export default AllEvents;